import React from "react";
import ReactApexChart from "react-apexcharts";
import { Box, Text } from "@fluentui/react-northstar";

// Reusable Pie Chart component using ApexCharts
const PieChart = ({
  options,
  data,
  height = 350,
}) => {

  return (
    <Box style={{ marginBottom: "2rem" }}>
      <div className="chart-container">
        <ReactApexChart
          options={options}
          series={data}
          type="pie"
          height={height}
        />
      </div>
    </Box>
  );
};

export default PieChart;
